import React, { useState, useEffect } from "react";
import {
  Drawer,
  Box,
  Typography,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { createMaleta } from "../../api/Maletas/maletasApi";
import { format } from "date-fns";
import { getAllUsers } from "../../api/User/userApi";

const DrawerNuevaMaleta = ({ open, onClose, onMaletaCreated }) => {
  const [nombre, setNombre] = useState("");
  const [usuario, setUsuario] = useState(""); // Usuario obligatorio
  const [fechaCreacion, setFechaCreacion] = useState(
    format(new Date(), "yyyy-MM-dd")
  );
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        const data = await getAllUsers();
        setUsuarios(data);
      } catch (error) {
        console.error("Error al obtener usuarios:", error);
      }
    };

    fetchUsuarios();
  }, []);

  const handleCreateMaleta = async () => {
    if (!nombre || !usuario) {
      alert("El nombre y el usuario son obligatorios");
      return;
    }

    try {
      await createMaleta({ nombre, usuarioId: usuario, fechaCreacion });
      onMaletaCreated(); // Refrescar lista de maletas
      onClose();
    } catch (error) {
      console.error("Error al crear la maleta:", error);
    }
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 350, p: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Nueva Maleta
        </Typography>

        {/* Nombre de la maleta */}
        <TextField
          label="Nombre de la maleta"
          fullWidth
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          sx={{ mb: 2 }}
          required
        />

        {/* Usuario responsable */}
        <FormControl fullWidth required sx={{ mb: 2 }}>
          <InputLabel>Usuario Responsable</InputLabel>
          <Select value={usuario} onChange={(e) => setUsuario(e.target.value)}>
            {usuarios.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                {user.username}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Fecha de creación (deshabilitada, solo lectura) */}
        <TextField
          label="Fecha de Creación"
          type="date"
          fullWidth
          value={fechaCreacion}
          disabled
          sx={{ mb: 2 }}
        />

        {/* Botón Crear */}
        <Button variant="contained" fullWidth onClick={handleCreateMaleta}>
          Crear Maleta
        </Button>
      </Box>
    </Drawer>
  );
};

export default DrawerNuevaMaleta;
